export default {
  init() {
    this.populateJobs();
    this.jobPopupShow();
  },
  populateJobs() {
    let board_name = $('section.careers-greenhouse').data('board');
    let api_base = 'https://boards-api.greenhouse.io/v1/boards/'
    let api_url = api_base + board_name +'/jobs?content=true';
    let start_time = new Date().getTime();
    // Populate jobs from JSON
    
    $.ajax({
      url: api_url,
      type: 'GET',
      dataType: 'json',
      async: true,
      success: function (data) {
        console.log(
          api_url,
          ' Request took ',
          new Date().getTime() - start_time,
          'ms'
        );
        // Create top-level locations list
        let locations = [];

        $.each(data.jobs, function () {
          if (typeof this.location != 'undefined' && typeof this.location.name != 'undefined' && !locations.includes(this.location.name)) {
            locations.push(this.location.name);
          }
        });
        
        // Arrange locations list alphabetically
        locations.sort(); 

        // Create top-level department list
        let departments = [];
          
        $.each(data.jobs, function () {
          if (typeof this.departments[0] != 'undefined' && typeof this.departments[0].name != 'undefined' && !departments.includes(this.departments[0].name)) {
            departments.push(this.departments[0].name);
          }
        })

        // Arrange department list alphabetically
        departments.sort();

        
        // Take prospect jobs and put them at end of list
        let all_jobs = [];
        let prospect_jobs = [];

        $.each(data.jobs, function () {
          if (this.title.indexOf('?') > -1) {
            prospect_jobs.push(this);
          } else {
            all_jobs.push(this);
          }
        })
        
        $.each(prospect_jobs, function () {
          all_jobs.push(this);
        })

        let html = '';
        
        // Build dropdown
        let selectHtml = '<select class="location-filter">';
        selectHtml += '<option value="all">Show all</option>';

        $.each(locations, function () { 
          let locationName = this;
          
          selectHtml += '<option value="' + locationName + '">' + locationName + '</option>';
        })
        selectHtml += '</select>';


        // Build department row
        $.each(departments, function (index) {

          html += '<div class="jobs-dept mt-14 mb-3" data-department="'+this+'">'
          html += '<h2>' + this + '</h2>';

          $.each(locations, function () {
            // Build location row
            let locationName = this;
            let display = false;
            // Check for a department job
              $.each(all_jobs, function () {
                if (typeof this.departments[0] != 'undefined' && this.departments[0].name === departments[index] && this.location.name === locationName) {
                  // Check if a departement/region is populated
                  display = true;
                }
              })
              if (display == true) {
                // Show region if populated
                html += '<div class="jobs-region mt-4 mb-3" data-location="'+locationName+'">'
                html += '<h3 class="location">' + locationName + '</h3>';
              }
              
              $.each(all_jobs, function () {

                // Build job row
                if (typeof this.departments[0] != 'undefined' && this.departments[0].name === departments[index] && this.location.name === locationName) {
                  html += '<div class="job" data-id="' + this.id + '" data-location="' + this.location.name + '">';
                  html += '<div class="accordion-items career-accordion-items py-2">';
                  html += '<h4 class="d-inline-block">' + this.title + '</h4><div class="arrow mr-2"></div>';
                  html += '</div>';
                  html += '</div>';
                }
              })
            if (display == true) {
              html += '</div>'; // close .jobs-region
            }
          })
          html += '</div>'; // close .jobs-dept
        })

        // Add drop-down to container
        $('.job-list').append(selectHtml);

        // Add HTML to container
        $('.job-list').append(html);
      },
    });

    $(document).on('change', '.location-filter', function () { 
      let currentLocation = $(this).val();
      
      if (currentLocation === 'all') { 
        $('.jobs-region').show();
        $('.jobs-dept').show();
      } else {
        $('.jobs-region').hide();
        $('.jobs-region[data-location="' + currentLocation + '"]').show();
        // Hide unpopulated regions
        $('.jobs-dept').each(function () { 
          $(this).show();
          if ($(this).children('.jobs-region:visible').length === 0) { 
            $(this).hide();
          }
        })
      }
    })
  },
  jobPopupShow() { 
    // direct to page with query string for target job
    $(document).on('click', '.job', function () { 
      window.location.href = window.location.href + '/job?gh_jid=' + $(this).data('id');
    })
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateGreenhouse.js